import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

/** Dark-violet tab-bar surface (design chrome) — sits above the page bg so the purple active pill pops. */
const TAB_BAR_SURFACE = '#1B1430';
const TAB_BAR_BORDER = 'rgba(255,255,255,0.08)';
const TAB_LABEL_INACTIVE = 'rgba(255,255,255,0.72)';

export function getMatchHubTabBarStyles(theme: Theme) {
  return StyleSheet.create({
    bar: {
      flexDirection: 'row',
      backgroundColor: TAB_BAR_SURFACE,
      borderWidth: 1,
      borderColor: TAB_BAR_BORDER,
      marginHorizontal: theme.spacing.lg,
      marginTop: -theme.spacing.md,
      marginBottom: theme.spacing.md,
      borderRadius: theme.borderRadius.lg,
      padding: 5,
    },
    tab: {
      flex: 1,
      paddingVertical: theme.spacing.sm,
      borderRadius: theme.borderRadius.md,
      alignItems: 'center',
      justifyContent: 'center',
    },
    tabActive: {
      backgroundColor: theme.primary,
    },
    label: {
      ...theme.typography.labelSmall,
      color: TAB_LABEL_INACTIVE,
      opacity: 1,
    },
    labelActive: {
      color: theme.onPrimary,
      fontWeight: '700',
    },
  });
}
